<!--
@Author: Florian Merel <florian>
@Date:   05-Jan-2021
@Email:  florian.merel@prokov.com
@Project: ComEditServer
@Filename: TicketsEnAttente.vue
@Last modified by:   florian
@Last modified time: 06-Jan-2021
-->

<template>
  <div>
    <md-table v-if="tickets" v-model="tickets">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell>
          <div class="md-layout">
            <div class="md-layout" style="margin-top: 5px">
              <ticket :item="item" :edition_all="edition_all"></ticket>
            </div>
          </div>
        </md-table-cell>
        <md-table-cell> </md-table-cell>
      </md-table-row>
    </md-table>

    <div v-if="tickets && tickets.length == 0">
      <div class="md-layout">
        <div class="md-layout-item md-small-size-100 md-size-100">
          <div style="text-align: center">Aucun ticket trouvé.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import Ticket from "./Ticket.vue";

export default {
  name: "tickets-table-en-attente",
  components: {
    Ticket,
  },
  props: ["edition_all"],
  created: function () {
    store.dispatch("tickets/serviceTicketEnAttente");
  },
  computed: {
    tickets() {
      let ti = store.getters["tickets/getTicketEnAttente"];
      if (ti == null) {
        return [];
      }
      return ti.tickets;
    },
  },
};
</script>
